// CSS
import { fileDownload } from 'Admin/Component/AdFunc';
import { useState } from 'react'
import '_Asset/css/User/Page/design.css'
import '_Asset/css/User/Page/UiComponent/input.css'

const Input = () => {

  const [uploadFile, setUploadFile] = useState('');
	
  return (
    <div className="componentBox inputs">
      <div className="pageTit">
        <h2>Inputs <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
        <p>Components: <span>Input, Input file, Textarea</span></p>
      </div> 

			{/* Use Way */}
      <div className="useWay">
        <h2>How to use the Input kit</h2>
        <p>Click input to copy and paste where you want to use it.</p>
        <p>Essential Class: <span>input, file / textarea</span></p>
        <p>Ex. class="<span>input line round_10 i_lt</span>"</p>
      </div>

			{/* Input Styles Types */}
      {inputArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>Input을 클릭하여 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.inputList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <label htmlFor="">label</label>
                
                <div className="field">
                  {
                    item.icon ?
                    <div className="inputIco">
                      <input type="text" className={`input ${item.size} ${item.type_1 ? item.type_1 : ''} ${item.type_2 ? item.type_2 : ''} ${item.type_3 ? item.type_3 : ''} ${item.type_4 ? item.type_4 : ''}`} placeholder={item.placeholder} ></input>
                      <i className={item.icon}></i>
                    </div>
                    :
                    <input type="text" className={`input ${item.size} ${item.type_1 ? item.type_1 : ''} ${item.type_2 ? item.type_2 : ''} ${item.type_3 ? item.type_3 : ''} ${item.type_4 ? item.type_4 : ''}`} placeholder={item.placeholder} readOnly={item.option === 'readonly' ? true : false} disabled={item.option === 'disabled' ? true : false}></input>
                  }
                </div>
                <h5 className={`fieldTxt ${item.type_2 === 'error' || item.type_2 === 'success' ? item.type_2 : ''}`}>{item.text}</h5>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Textarea Styles Types */}
      {textAreaArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>Textarea를 눌러 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.textAreaList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <label htmlFor="">Label</label>
                
                <div className={`field ${item.sample}`}>
                  <textarea type="text" className={`textarea round ${item.status}`} placeholder={item.placeholder} readOnly={item.readOnly} disabled={item.disabled}></textarea>
                </div>
                <h5 className={`fieldTxt ${item.status}`}>{item.text}</h5>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Inpur File Styles */}
      {fileArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>파일 업로드 Field를 클릭하여 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap file">
            {key.fileList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <label htmlFor="">{item.text}</label>
                
                <div className="field">
                  <label className={`input file ${item.size} ${item.id} round_10 ${uploadFile ? 'active' : ''}`} htmlFor={item.id}>{item.id === 'type_1' && (uploadFile ? uploadFile.name : '업로드할 파일을 선택해주세요.')}
                    <i className={uploadFile && item.id === 'type_2' ? 'icofont-file-alt' : item.icon}></i>
                    {item.id === 'type_2' && (uploadFile ? uploadFile.name : 'Drag and drop or browse your files')}
                  </label>
                  <input type="file" id={item.id} name="file" className="file" onChange={(e) => setUploadFile(e.target.files[0])}></input>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const inputArr = [
  {
    name: 'Input Styles Types',
    class: 'Class: [X (Default) / line / line_bg / line_none]',
    inputList: [
      {size: 'md', type_1: "round_10", placeholder: "Default", text: "Default Style"},
      {size: 'md', type_1: "line", placeholder: "line", text: "Single Line" },
      {size: 'md', type_1: "line_bg", placeholder: "line_bg", text: "Single Line with Background" },
      {size: 'md', type_1: "line_none", placeholder: "line_none", text: "None Line" },
    ]
  },
  {
    name: 'Input Round Types',
    class: 'Class: [X (Default) / round_10 / round_100]',
    inputList: [
      {size: 'md', placeholder: "Round X", text: "Round X"},
      {size: 'md', type_1: "round_10", placeholder: "round_10", text: "Border-radius 4px"},
      {size: 'md', type_1: "round_100", placeholder: "round_100", text: "Border-radius Maximum"},
    ]
  },
  {
    name: 'Input with Icon',
    class: 'Class: [input_ico / i_lt, i_rt]',
    inputList: [
      {size: 'md', type_1: "round_10", type_2: "i_lt", placeholder: "i_lt", text: "Left Position Icon", icon: "icofont-ui-user"},
      {size: 'md', type_1: "round_10", type_2: "i_rt", placeholder: "i_rt", text: "Right Position Icon", icon: "icofont-ui-check"}
    ]
  },
  {
    name: 'Default Input Styles',
    class: 'Use Class: [input, round_10, error, success, i_rt, i_lt]',
    inputList: [
      {size: 'md', type_1: "round_10", placeholder: "Default", text: "1. Default"},
      {size: 'md', type_1: "round_10", placeholder: "Read Only", option: "readonly", text: "2. Read Only"},
      {size: 'md', type_1: "round_10", placeholder: "Disabled", option: "disabled", text: "3. Disabled"},
      {size: 'md', type_1: "round_10", type_2: "hover", placeholder: "Hover", text: "4. Hover"},
      {size: 'md', type_1: "round_10", type_2: "focus", placeholder: "Focus", text: "5. Focus"},
      {size: 'md', type_1: "round_10", type_2: "error", placeholder: "Error", text: "6. Error", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "round_10", type_2: "error", type_3: "i_lt", placeholder: "Error", text: "6-1. Error with Right Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "round_10", type_2: "error", type_3: "i_rt", placeholder: "Error", text: "6-2. Error with Left Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "round_10", type_2: "success", placeholder: "Success", text: "7. Success"},
      {size: 'md', type_1: "round_10", type_2: "success", type_3: "i_lt", placeholder: "Success", text: "7-1. Success with Right Icon", icon: "icofont-ui-check"},
      {size: 'md', type_1: "round_10", type_2: "success", type_3: "i_rt", placeholder: "Success", text: "7-2. Success with Left Icon", icon: "icofont-ui-check"},
    ]
  },
  {
    name: 'Single Line Input Styles',
    class: 'Use Class: [input, line, error, success, i_rt, i_lt]',
    inputList: [
      {size: 'md', type_1: "line", placeholder: "Default", text: "1. Default"},
      {size: 'md', type_1: "line", placeholder: "Read Only", option: "readonly", text: "2. Read Only"},
      {size: 'md', type_1: "line", placeholder: "Disabled", option: "disabled", text: "3. Disabled"},
      {size: 'md', type_1: "line", type_2: "hover", placeholder: "Hover", text: "4. Hover"},
      {size: 'md', type_1: "line", type_2: "focus", placeholder: "Focus", text: "5. Focus"},
      {size: 'md', type_1: "line", type_2: "error", placeholder: "Error", text: "6. Error", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line", type_2: "error", type_3: "i_lt", placeholder: "Error", text: "6-1. Error with Right Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line", type_2: "error", type_3: "i_rt", placeholder: "Error", text: "6-2. Error with Left Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line", type_2: "success", placeholder: "Success", text: "7. Success"},
      {size: 'md', type_1: "line", type_2: "success", type_3: "i_lt", placeholder: "Success", text: "7-1. Success with Right Icon", icon: "icofont-ui-check"},
      {size: 'md', type_1: "line", type_2: "success", type_3: "i_rt", placeholder: "Success", text: "7-2. Success with Left Icon", icon: "icofont-ui-check"},
    ]
  },
  {
    name: 'Single Line with BG Input Styles',
    class: 'Use Class: [input, line_bg, error, success, i_rt, i_lt]',
    inputList: [
      {size: 'md', type_1: "line_bg", placeholder: "Default", text: "1. Default"},
      {size: 'md', type_1: "line_bg", placeholder: "Read Only", option: "readonly", text: "2. Read Only"},
      {size: 'md', type_1: "line_bg", placeholder: "Disabled", option: "disabled", text: "3. Disabled"},
      {size: 'md', type_1: "line_bg", type_2: "hover", placeholder: "Hover", text: "4. Hover"},
      {size: 'md', type_1: "line_bg", type_2: "focus", placeholder: "Focus", text: "5. Focus"},
      {size: 'md', type_1: "line_bg", type_2: "error", placeholder: "Error", text: "6. Error", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line_bg", type_2: "error", type_3: "i_lt", placeholder: "Error", text: "6-1. Error with Right Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line_bg", type_2: "error", type_3: "i_rt", placeholder: "Error", text: "6-2. Error with Left Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line_bg", type_2: "success", placeholder: "Success", text: "7. Success"},
      {size: 'md', type_1: "line_bg", type_2: "success", type_3: "i_lt", placeholder: "Success", text: "7-1. Success with Right Icon", icon: "icofont-ui-check"},
      {size: 'md', type_1: "line_bg", type_2: "success", type_3: "i_rt", placeholder: "Success", text: "7-2. Success with Left Icon", icon: "icofont-ui-check"},
    ]
  },
  {
    name: 'None Line Input Styles',
    class: 'Use Class: [input, line_none, error, success, i_rt, i_lt]',
    inputList: [
      {size: 'md', type_1: "line_none", type_2: "round_10", placeholder: "Default", text: "1. Default"},
      {size: 'md', type_1: "line_none", type_2: "round_10", placeholder: "Read Only", option: "readonly", text: "2. Read Only"},
      {size: 'md', type_1: "line_none", type_2: "round_10", placeholder: "Disabled", option: "disabled", text: "3. Disabled"},
      {size: 'md', type_1: "line_none", type_2: "round_10", type_3: "hover", placeholder: "Hover", text: "4. Hover"},
      {size: 'md', type_1: "line_none", type_2: "round_10", type_3: "focus", placeholder: "Focus", text: "5. Focus"},
      {size: 'md', type_1: "line_none", type_2: "error", type_3: "round_10", placeholder: "Error", text: "6. Error", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line_none", type_2: "error", type_3: "round_10", type_4: "i_lt", placeholder: "Error", text: "6-1. Error with Right Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line_none", type_2: "error", type_3: "round_10", type_4: "i_rt", placeholder: "Error", text: "6-2. Error with Left Icon", icon: "icofont-exclamation-circle", icon_2: "icofont-exclamation-circle"},
      {size: 'md', type_1: "line_none", type_2: "success", type_3: "round_10", placeholder: "Success", text: "7. Success"},
      {size: 'md', type_1: "line_none", type_2: "success", type_3: "round_10", type_4: "i_lt", placeholder: "Success", text: "7-1. Success with Right Icon", icon: "icofont-ui-check"},
      {size: 'md', type_1: "line_none", type_2: "success", type_3: "round_10", type_4: "i_rt", placeholder: "Success", text: "7-2. Success with Left Icon", icon: "icofont-ui-check"},
    ]
  },
]

const textAreaArr = [
  {
    name: 'TextArea Type 1',
    class: 'Class: [textarea]',
    textAreaList: [
      {placeholder: "Default", text: "1. Default", readOnly: false, disabled: false, sample: '', status: '' },
      {placeholder: "Read Only", text: "2. Read Only", readOnly: true, disabled: false, sample: '', status: '' },
      {placeholder: "Disabled", text: "3. Disabled", readOnly: false, disabled: true, sample: '', status: '' },
      {placeholder: "Hover", text: "4. Hover", readOnly: false, disabled: false, sample: 'hover', status: '' },
      {placeholder: "Focus", text: "5. Focus", readOnly: false, disabled: false, sample: 'focus', status: '' },
      {placeholder: "Error", text: "6. Error", readOnly: false, disabled: false, sample: '', status: 'error' },
      {placeholder: "Sucess", text: "7. Success", readOnly: false, disabled: false, sample: '', status: 'success' },
    ]
  },
]

const fileArr = [
  {
    name: 'File upload - Select',
    class: 'Class: [input file type_1]',
    fileList: [
      { id: 'type_1', size: 'md', text: 'Select', icon: 'icofont-link'},
    ]
  },
  {
    name: 'File upload - Drag and Drop',
    class: 'Class: [input file type_2]',
    fileList: [
      { id: 'type_2', size: 'md', text: 'File upload - Drag and Drop', icon: 'icofont-upload-alt' },
    ]
  },
]

export default Input